/** Shared interaction policy for every storefront. Brand logo sizing and
 * editorial colours remain template settings, never touch/scroll mechanics. */
export const nativeHorizontalCarousels = true
